const EXIT_ID = process.env.NICKL_EXT_ID
const EDGE_EXIT_ID = process.env.EDGE_NICKL_EXT_ID

const getDKTokenForUser = () => {
  return fetch("/user/generate-dk-token", {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json'
    }
  })
    .then(res => res.json())
    .then(res => {
      return res
    })
    .catch(err => {
      console.log("get token error: ", err)
      return null
    })
}

const getLiteShareAndCredential = (liteShareId) => {
  return fetch(`/lite_share/ext-data?id=${liteShareId}`, {
    method: 'GET',
    headers: {
      'Content-Type': 'application/json'
    }
  })
    .then(res => res.json())
    .then(res => {
      return res
    })
    .catch(err => {
      console.log("get liteshare launch error: ", err)
      return null
    })
}

const getExtensionVersion = () => {
  return new Promise((resolve, reject) => {
    if (!window.chrome?.runtime) {
      reject()
      return
    }

    chrome.runtime.sendMessage(EXIT_ID, { versionCheck: true }, (response) => {
      if (chrome.runtime.lastError || !response) {
        chrome.runtime.sendMessage(EDGE_EXIT_ID, { versionCheck: true }, (edgeResponse) => {
          if (chrome.runtime.lastError || !edgeResponse) reject()
          else resolve(edgeResponse)
        })
      } else {
        resolve(response)
      }
    })
  })
}

const sendAuthDataToExtension = (authData) => {
  return new Promise((resolve, reject) => {
    chrome.runtime.sendMessage(EXIT_ID, { authData }, (response) => {
      if (chrome.runtime.lastError || !response) {
        chrome.runtime.sendMessage(EDGE_EXIT_ID, { authData }, (edgeResponse) => {
          if (chrome.runtime.lastError || !edgeResponse) reject()
          else resolve(edgeResponse)
        })
      } else {
        resolve(response)
      }
    })
  })
}

const sendAuthToExtension = (authData) => {
  return new Promise((resolve, reject) => {
    const timeout = window.setTimeout(() => {
      window.removeEventListener('message', onResult)
      sendAuthDataToExtension(authData).then(resolve).catch(reject)
    }, 5000)

    const onResult = (event) => {
      if (event.source !== window || event.data?.type !== 'NICKLPASS_EXTENSION_AUTH_RESULT') return
      window.clearTimeout(timeout)
      window.removeEventListener('message', onResult)
      if (event.data.success) resolve(true)
      else sendAuthDataToExtension(authData).then(resolve).catch(reject)
    }

    window.addEventListener('message', onResult)
    window.postMessage({ type: 'NICKLPASS_EXTENSION_AUTH', authData }, '*')
  })
}

const sendLiteShareToExtension = (liteShareData) => {
  chrome.runtime.sendMessage(EXIT_ID, {liteShare: liteShareData}, (response) => {
    if (chrome.runtime.lastError) {
      // First extension did not respond. Try the second one.
      chrome.runtime.sendMessage(EDGE_EXIT_ID, {liteShare: liteShareData}, (response) => {
        window.close();
      });
    } else {
      // First extension responded.
      window.close();
    }
  });
}

const redirectToLiteGetExtensionPage = () => {
  window.location.replace("/lite/get_extension")
}

const redirectToTrialGetExtensionPage = () => {
  window.location.replace("/trial/get_extension")
}

const redirectToGetExtensionPage = () => {
  window.location.replace("/get_extension")
}

const redirectToSSODeepLink = (authData) => {
  window.location = `nicklpass://auth/saml?access_token=${authData.access_token}&refresh_token=${authData.refresh_token}`
}

const logCurrentUserIntoExtension = () => {
  return new Promise((resolve, reject) => {
    const tokenSource = window.NICKL_EXTENSION_AUTH?.access_token
      ? Promise.resolve(window.NICKL_EXTENSION_AUTH)
      : getDKTokenForUser()

    tokenSource.then(authData => {
      if (authData) {
        document.body.dataset.token = authData.access_token
        sendAuthToExtension(authData).then(resolve).catch(reject)
      } else {
        reject()
      }
    }).catch(reject)
  })
}

const confirmExtensionCommunication = () => {
  return new Promise((resolve, reject) => {
    if (window.chrome?.runtime) {
      getExtensionVersion().then(version => {
        console.log("got ext vers: ", version)
        version ? resolve(true) : reject(false)
      })
    } else {
      reject(false)
    }
  })
}

const runTrialConfirmProcess = () => {
  // Hide until we know extension is installed...
  $("#trial-confirm").hide()

  confirmExtensionCommunication()
    .then((res) => {
      $("#trial-confirm").show()
      logCurrentUserIntoExtension()
    })
    .catch((err) => {
      redirectToTrialGetExtensionPage()
    })
}

const runLiteShareLaunchProcess = () => {
  // Hide until we know extension is installed...
  $("#lite-share-launch").hide()
  const liteShareId = $("#lite-share-launch").data("lite-share-id")

  confirmExtensionCommunication()
    .then((res) => {
      $("#lite-share-launch").show()
      getLiteShareAndCredential(liteShareId)
        .then(resData => {
          return sendLiteShareToExtension(resData)
        })
        .catch((err) => {
          $("#lite-share-launch > .error").removeClass("hidden")
        })
    })
    .catch((err) => {
      redirectToLiteGetExtensionPage()
    })
}

const ssoExtensionLoginProcess = () => {
  const login = window.NICKL_EXTENSION_AUTH?.access_token
    ? logCurrentUserIntoExtension()
    : confirmExtensionCommunication().then(() => logCurrentUserIntoExtension())

  return login
    .then(() => {
      const status = document.getElementById('nickl-extension-auth-status')
      if (status) {
        status.textContent = 'Signed in. You can close this tab and open NICKLpass.'
        status.className = 'alert alert-success mb-4'
      }
      window.setTimeout(() => window.close(), 10000)
    })
    .catch((error) => {
      console.error('Extension login bridge failed:', error)
      const status = document.getElementById('nickl-extension-auth-status')
      if (status) {
        status.textContent = 'Could not reach the NICKLpass extension. Rebuild/reload the extension, then try again.'
        status.className = 'alert alert-warning mb-4'
      }
    })
}

const ssoMobileLoginProcess = () => {
  getDKTokenForUser().then(authData => {
    if (authData) {
      redirectToSSODeepLink(authData)
    } else {
      $(".error").removeClass("hidden")
    }
  })
}

$(document).ready(() => {
  // Trial confirmation page
  if ($("#trial-confirm").length > 0) {
    runTrialConfirmProcess()
  }

  // Lite Share launch page
  if ($("#lite-share-launch").length > 0) {
    runLiteShareLaunchProcess()
  }

  // SSO Extension login page
  if ($("#all-extension-login").length > 0) {
    ssoExtensionLoginProcess().then(() => {
      let firstName = $('body').data('currentUserFirstName');
      let lastName = $('body').data('currentUserLastName');
      let email = $('body').data('currentUserEmail');
      let isFreeTrial = $('body').data('isFreeTrial');
      let token = $('body').data('token');
      if (isFreeTrial && !!token) {
        window.location.href = `https://selfservice.nicklpass.com/testlog?first_name=${firstName}&last_name=${lastName}&email=${email}&token=${token}`;
      }
    }).catch((error) => {
      console.error("Error in ssoExtensionLoginProcess:", error);
    });
  }

  // SSO Mobile login page
  if ($("#sso-mobile-callback").length > 0) {
    ssoMobileLoginProcess()
  }
});
